import {
	SceneState,
	POINTER_OVER_DROP_AREA,
	SET_SCENE_DATA,
	SELECT_SCENE_ITEM,
	SELECT_SCENE_ARTICLE,
	REMOVE_SCENE_ITEM,
	REMOVE_ALL_SCENE_ITEMS,
	ROTATE_SCENE_ITEM,
	MOVE_BACKREST,
	DISABLE_MOVE_BACKREST,
	SET_SCENE_ITEM_COVER,
	SET_COLOR_FOR_ALL,
	DRAG_SCENE_ITEM_ID,
	OVER_SCENE_ITEM_ID,
	ADD_CUSHIONS,
	SET_ENVIRONMENTAL_LIGHTING,
	SET_LIGHT_INTENSITY,
	ANIMATE_CAMERA_ROTATION,
	SET_MEASUREMENTS,
	SET_HELPER_POSITION,
	RESET_CAMERA_ROTATION,
	SET_KEEP_SCENE_HEIGHT,
	SET_NO_ROTATION_ICON,
	SHOW_ROTATION_ICON,
	SET_KEEP_MODULE,
	MOVE_BACKREST_AS_ARMREST,
	DISABLE_MOVE_BACKREST_AS_ARMREST,
	BACKREST_AS_ARMREST,
	SET_SPECIFIC_SELECTED_ITEMS,
} from './types';
import { Actions } from '..';
import {
	SET_SHOW_FUNCTION_SLEEP,
	SET_SHOW_FUNCTION_STORAGE,
	SET_SHOW_MEASUREMENTS,
} from '../actionButtons/types';
import { SET_APP_VIEW } from '../application/types';

const initialState: SceneState = {
	pointerOverDropArea: false,
	resetCameraRotation: false,
	keepSceneHeight: false,
	sceneItems: [],
	showRotationIcon: false,
	noRotationIcon: false,
	keepModule: false,
};

export function sceneReducer(state = initialState, action: Actions): SceneState {
	switch (action.type) {
		case SET_SCENE_DATA: {
			const { sceneItems } = action;

			return {
				...state,
				sceneItems: sceneItems,
				backrestsMissingCushion: action.backrestsMissingCushion,
			};
		}
		case SELECT_SCENE_ITEM:
			// Reset removeSceneItem when no item is selected
			const removeSceneItem = action.item ? state.removeSceneItem : null;
			return { ...state, selectedSceneItem: action.item, removeSceneItem };

		case SELECT_SCENE_ARTICLE:
			return { ...state, selectedSceneArticle: action.value };
		case REMOVE_SCENE_ITEM:
			return { ...state, removeSceneItem: action.item };
		case REMOVE_ALL_SCENE_ITEMS:
			return { ...state, removeAllSceneItems: action.value };
		case ROTATE_SCENE_ITEM:
			return { ...state, rotateSceneItem: action.item };
		case MOVE_BACKREST:
			return { ...state, moveBackrest: action.item };
		case DISABLE_MOVE_BACKREST:
			return { ...state, disableMoveBackrest: action.value };
		case MOVE_BACKREST_AS_ARMREST:
			return { ...state, moveBackrestAsArmrest: action.item };
		case DISABLE_MOVE_BACKREST_AS_ARMREST:
			return { ...state, disableMoveBackrestAsArmrest: action.value };
		case BACKREST_AS_ARMREST:
			return { ...state, backrestAsArmrest: action.item };
		case SET_SCENE_ITEM_COVER:
			return {
				...state,
				setSceneItemCover: action.sceneItemCoverConnection,
			};
		case SET_COLOR_FOR_ALL:
			return { ...state, colorForAll: action.value };
		case DRAG_SCENE_ITEM_ID:
			return { ...state, dragSceneItemId: action.value };
		case OVER_SCENE_ITEM_ID:
			return { ...state, overSceneItemId: action.value };
		case ADD_CUSHIONS:
			return { ...state, addCushions: action.value };
		case SET_ENVIRONMENTAL_LIGHTING:
			return { ...state, environmentalLighting: action.value };
		case SET_LIGHT_INTENSITY:
			return { ...state, lightIntensity: action.value };
		case ANIMATE_CAMERA_ROTATION: {
			return { ...state, animateCameraRotation: action.value, selectedSceneItem: null };
		}
		case SET_MEASUREMENTS: {
			return { ...state, measurements: action.value };
		}
		case POINTER_OVER_DROP_AREA:
			return { ...state, pointerOverDropArea: action.value };
		case SET_HELPER_POSITION: {
			return { ...state, sceneHelper: action.value };
		}
		case SET_SHOW_FUNCTION_SLEEP:
		case SET_SHOW_FUNCTION_STORAGE: {
			return { ...state, selectedSceneItem: null };
		}
		case SET_SHOW_MEASUREMENTS: {
			return { ...state, selectedSceneItem: null };
		}
		case SET_APP_VIEW: {
			const disableStuff = action.value === 'summary-page';
			const selectedSceneItem = disableStuff ? null : state.selectedSceneItem;
			return { ...state, selectedSceneItem };
		}
		case RESET_CAMERA_ROTATION: {
			return { ...state, resetCameraRotation: action.value };
		}
		case SET_KEEP_SCENE_HEIGHT: {
			return { ...state, keepSceneHeight: action.value };
		}
		case SHOW_ROTATION_ICON: {
			return { ...state, showRotationIcon: action.value };
		}
		case SET_NO_ROTATION_ICON: {
			return { ...state, noRotationIcon: action.value };
		}
		case SET_KEEP_MODULE: {
			return { ...state, keepModule: action.value };
		}
		case SET_SPECIFIC_SELECTED_ITEMS: {
			return { ...state, specificSelectedItems: action.items };
		}
		default:
			return state;
	}
}
